import { routeUrls } from "../../../src/routes";

export const Restricted = () => {
    return (
        <div className="container mx-auto h-full">
            <div className="flex flex-col items-center justify-center h-full">
                <h1 className="text-3xl font-bold">Toegang beperkt</h1>
                <p className="text-xl">Je hebt geen bevoegdheid om deze pagina te bezoeken.</p>
                <a
                    className="rounded bg-primary text-white px-5 py-2 mt-10"
                    href={routeUrls.DASHBOARD}
                >
                    Ga naar mijn dashboard
                </a>
            </div>
        </div>
    );
};
